import React from 'react';
import { Card, CardContent, Typography } from '@mui/material';
import { Line } from 'react-chartjs-2';
import {
  Chart as ChartJS,
  CategoryScale,
  LinearScale,
  PointElement,
  LineElement,
  Title,
  Tooltip,
  Legend
} from 'chart.js';

ChartJS.register(CategoryScale, LinearScale, PointElement, LineElement, Title, Tooltip, Legend);

const AnalyticsChart = ({ analytics }) => {
  // Format daily labels like "10 May 2025"
  const dailyLabels = analytics.daily.map((d) => {
    const { day, month, year } = d._id;
    return new Date(year, month - 1, day).toLocaleDateString('en-GB', {
      day: '2-digit',
      month: 'short',
      year: 'numeric'
    });
  });

  // Format monthly labels like "May 2025"
  const monthlyLabels = analytics.monthly.map((m) => {
    const { month, year } = m._id;
    return new Date(year, month - 1).toLocaleDateString('en-GB', {
      month: 'short',
      year: 'numeric'
    });
  });

  return (
    <Card>
      <CardContent>
        <div className='row'>
                    <div className='col-6'>
        <Typography variant="h6">Analytics</Typography>

        {/* Daily */}
        <Typography variant="subtitle1" style={{ marginTop: 16 }}>
          Daily Footfall
        </Typography>
        <Line
          data={{
            labels: dailyLabels,
            datasets: [
              {
                label: 'Users Entered',
                data: analytics.daily.map((d) => d.count),
                borderColor: '#4caf50',
                backgroundColor: '#c8e6c9',
                tension: 0.4
              }
            ]
          }}
        />
    </div>
        {/* Monthly */}
        <div className='col-6'>
        <Typography variant="subtitle1" style={{ marginTop: 32 }}>
          Monthly Footfall
        </Typography>
        <Line
          data={{
            labels: monthlyLabels,
            datasets: [
              {
                label: 'Monthly Users',
                data: analytics.monthly.map((m) => m.count),
                borderColor: '#2196f3',
                backgroundColor: '#bbdefb',
                tension: 0.4
              }
            ]
          }}
        />

        {/* Total Unique Users */}
        <Typography variant="subtitle1" style={{ marginTop: 32 }}>
          Total Unique Users: <strong>{analytics.totalUniqueUsers}</strong>
        </Typography>
        </div>
</div>
      </CardContent>
    </Card>
  );
};

export default AnalyticsChart;
